import TaskForm, { TaskField } from "../TaskForm";
import ParcelService from "../../../services/parcelService";
import { PlantProtectionTask } from "../../../interfaces/PlantProtectionTask";

interface CreateEntryFormProps {
    onSave: (newEntry: PlantProtectionTask) => void;
    parcelId: number;
    cycleId: number;
    isNew: boolean;
    task?: PlantProtectionTask;
    readOnly?: boolean;
}

export default function PlantProtectionCreateForm(props: CreateEntryFormProps) {
    const parcelService = new ParcelService();

    const fields: TaskField[] = [
        { name: "date", label: "Datum", type: "date", required: true },
        { name: "kind", label: "Art", type: "text", required: true },
        { name: "quantity", label: "Menge (pro/ha)", type: "number", required: true },
        { name: "note", label: "Notizen", type: "textarea" }
    ] as const;

    const defaultState: PlantProtectionTask = {
        id: "",
        date: new Date(),
        kind: "",
        quantity: 0,
        note: ""
    };

    return (
        <TaskForm<PlantProtectionTask>
            title="Pflanzenschutz"
            fields={fields}
            isNew={props.isNew}
            task={props.task}
            defaultState={defaultState}
            onSubmit={async (data) => {
                if (props.isNew) {
                    await parcelService.createPlantProtectionTask(props.parcelId, props.cycleId, data);
                } else {
                    await parcelService.updatePlantProtectionTask(props.parcelId, props.cycleId, Number(data.id), data);
                }
                await props.onSave(data);
            }}
            readOnly={props.readOnly}
        />
    );
}
